/* global axios */
import ApiClient from './ApiClient';

class ShopifyOrderActionsAPI extends ApiClient {
  constructor() {
    super('shopify_order_actions', { accountScoped: true });
  }

  get(params) {
    return axios.get(this.url, { params });
  }

  context(params) {
    return axios.get(`${this.url}/context`, { params });
  }

  catalog(params) {
    return axios.get(`${this.url}/catalog`, { params });
  }

  submit(id) {
    return axios.post(`${this.url}/${id}/submit`);
  }

  approve(id) {
    return axios.post(`${this.url}/${id}/approve`);
  }

  decline(id, reason) {
    return axios.post(`${this.url}/${id}/decline`, { reason });
  }

  policies() {
    return axios.get(`${this.url}/staff_policies`);
  }

  updatePolicy(userId, mode) {
    return axios.patch(`${this.url}/update_policy`, { user_id: userId, mode });
  }
}
export default new ShopifyOrderActionsAPI();
